import React from "react";
import { MainHeader } from "../components/global/MainHeader";
import { ShopSection } from "../components/Shop/ShopSection";
import { Socials } from "../components/Home/Socials";
import { getAllDocuments } from "../firebase/firebaseCrud";
import { useCart } from "../context/cart-context";

const Shop = () => {
  const { isLoading, setIsLoading } = useCart();

  const [products, setProducts] = React.useState([]);

  const getProducts = async () => {
    const prods = await getAllDocuments("product-list");
    setProducts(prods);
  };

  React.useEffect(() => {
    getProducts();
  }, []);

  // console.log("Shop products", products);

  React.useEffect(() => {
    if (products.length <= 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [products]);

  return (
    <React.Fragment>
      <MainHeader name={"Shop"} />
      <ShopSection data={products} />
      <Socials imgSrc={"SBD/StrandsHairs.png"} />
    </React.Fragment>
  );
};

export default Shop;
